import React, { Component, createRef } from "react";
import { withSelect, withDispatch } from "@wordpress/data";
import { __ } from '@wordpress/i18n';
import PropTypes from 'prop-types';
import inputs from "../inputs";

import './style.scss';
import PanelFooter from "../PanelFooter";

class Panel extends Component {
	state ={
		saving: false,
		reseting: false,
	}
	footerEl = createRef();
	observer = null;
	componentDidMount() {
		this.observer = new IntersectionObserver( 
		([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1),
		{threshold: [1]}
		);
		window.addEventListener( 'load', this.stickyObserver );
		window.addEventListener( 'beforeunload', this.dontCloseUnsave );
	}
	componentWillUnmount() {
		window.removeEventListener( 'load', this.stickyObserver );
		window.addEventListener( 'beforeunload', this.dontCloseUnsave );

		if ( this.observer ) {
			this.observer.disconnect();
		}
	}
	stickyObserver = () => {
		if ( this.footerEl.current && this.observer ) {
			this.observer.observe(this.footerEl.current);
		}
	}
	dontCloseUnsave = ( e ) => {
		e = e || window.event;
		const { notSaved } = this.props;

		if ( ! notSaved ) {
			return false;
		}
		// For IE and Firefox prior to version 4
		if ( e ) {
			e.returnValue = __( 'Changed will not save. Are you sure to leave?', 'wp-offers' );
		}

		// For Safari
		return __( 'Changed will not save. Are you sure to leave?', 'wp-offers' );
	}
	getOptionsId = ( tabs, ids ) => {
		let optionsId = ids === undefined ? [] : ids;
		tabs.forEach(tab => {
			if ( tab.tabs !== undefined ) {
				optionsId = this.getOptionsId( tab.tabs, optionsId );
			} else if ( tab.options !== undefined ) {
				tab.options.forEach( option => {
					optionsId.push( option.id );
				} );
			}
		});

		return optionsId;
	}
	setReseting = ( reseting ) => {
		this.setState( {
			reseting,
		} );
	}
	setSaving = ( saving ) => {
		this.setState( {
			saving,
		} );
	}
	render() {
		const { active, activeSubTabs, allOptions, resetOptions, updateNotSaved } = this.props;
		const activeTab = kitOptions !== undefined && kitOptions[active] !== undefined ? kitOptions[active] : {};
		const activeSubTab = activeSubTabs[activeTab.id] || 0;
		const isSubTab = activeTab.tabs !== undefined;
		return(
			<>
				{
					isSubTab ?
					<>
					{
						activeTab.tabs[activeSubTab] && activeTab.tabs[activeSubTab].options &&
						activeTab.tabs[activeSubTab].options.map( option => {
							const Input = inputs( option.type );

							return <Input key={ option.id } {...option} />
						} )
					}
					</>
					:
					<>
					{
						activeTab.options &&
						activeTab.options.map( option => {
							const Input = inputs( option.type );

							return <Input key={ option.id } {...option} />
						} )
					}
					</> 
				}
				<div className="options-kit-footer" ref={ this.footerEl }>
					<PanelFooter
						saving={ this.state.saving }
						reseting={ this.state.reseting }
						setReseting={ this.setReseting }
						setSaving={ this.setSaving }
						getOptionsId={ this.getOptionsId }
						allOptions={ allOptions }
						resetOptions={ resetOptions }
						updateNotSaved={ updateNotSaved }
					/>
				</div>
			</>
		);
	}
}

Panel.propTypes = {
	active: PropTypes.number,
	activeSubTabs: PropTypes.object,
	allOptions: PropTypes.oneOfType( [
		PropTypes.object,
		PropTypes.array,
	] ),
	resetOptions: PropTypes.func,
};

export default withDispatch( dispatch => {
	const { resetOptions, updateNotSaved } = dispatch( 'options-kit' );
	return  {
		resetOptions,
		updateNotSaved,
	};
} )( withSelect( ( select ) => {
	const { getActiveTab, getActiveSubTabs, getAllOptions, getNotSaved } = select( 'options-kit' );
	return {
		active: getActiveTab(),
		activeSubTabs: getActiveSubTabs(),
		allOptions: getAllOptions(),
		notSaved: getNotSaved(),
	}
} )( Panel ) );